import React from "react";
import { ImCross } from "react-icons/im";
import { useDispatch } from "react-redux";
import {
  deleteItem,
  drecreaseQuantity,
  increaseQuantity,
} from "../../redux/orebiSlice";

const ItemCard = ({ item }) => {
  const dispatch = useDispatch();
  return (
    <div className="relative flex flex-col mdl:flex-row items-center gap-4 p-4 hover:bg-gray-50 transition-colors duration-200">
      {/* Product Image and Name */}
      <div className="flex flex-col mdl:flex-row items-center gap-4 flex-grow">
        <div className="relative group">
          <img 
            className="w-32 h-32 object-cover rounded-lg shadow-sm transform transition-transform duration-300 group-hover:scale-105" 
            src={item.image} 
            alt={item.name} 
          />
        </div>
        <h1 className="font-titleFont text-lg font-semibold text-center mdl:text-left">
          {item.name}
        </h1>
      </div>

      {/* Price, Quantity, and Actions */}
      <div className="flex flex-col mdl:flex-row items-center gap-6 mt-4 mdl:mt-0">
        {/* Price */}
        <div className="text-lg font-semibold text-gray-800">
          EGP {item.price}
        </div>

        {/* Quantity Controls */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => dispatch(drecreaseQuantity({ _id: item._id }))}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 active:bg-gray-300 transition-colors duration-200"
          >
            <span className="text-lg font-medium">-</span>
          </button>
          <span className="w-10 text-center font-medium text-lg">
            {item.quantity}
          </span>
          <button
            onClick={() => dispatch(increaseQuantity({ _id: item._id }))}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 active:bg-gray-300 transition-colors duration-200"
          >
            <span className="text-lg font-medium">+</span>
          </button>
        </div>

        {/* Subtotal */}
        <div className="font-titleFont font-bold text-lg text-gray-800 min-w-[80px] text-center">
          EGP {(item.quantity * item.price).toFixed(2)}
        </div>

        {/* Delete Button */}
        <button
          onClick={() => dispatch(deleteItem(item._id))}
          className="p-2 rounded-full hover:bg-red-50 transition-colors duration-200 group"
        >
          <ImCross className="text-gray-400 group-hover:text-red-500 transition-colors duration-200" />
        </button>
      </div>
    </div>
  );
};

export default ItemCard;
